import { render } from "./privacypage.vue?vue&type=template&id=7b325bb9&scoped=true"
import script from "./privacypage.vue?vue&type=script&lang=js"
export * from "./privacypage.vue?vue&type=script&lang=js"

import "./privacypage.vue?vue&type=style&index=0&id=7b325bb9&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\personal\\ims-frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b325bb9"]])

export default __exports__